/**
 * Several small helper functions and common data
 *
 * (c) Kaden und Partner AG
 */

import { validateRegex } from '@/helpers/model_validators';
import { getI18n } from './i18n';

/**
 * An array with all Kantone
 */
export const kantone = [
    { kuerzel: 'ag', kurz: 'AG', lang: 'Aargau' },
    { kuerzel: 'ai', kurz: 'AI', lang: 'Appenzell Innerrhoden' },
    { kuerzel: 'ar', kurz: 'AR', lang: 'Appenzell Ausserrhoden' },
    { kuerzel: 'be', kurz: 'BE', lang: 'Bern' },
    { kuerzel: 'bl', kurz: 'BL', lang: 'Basel-Landschaft' },
    { kuerzel: 'bs', kurz: 'BS', lang: 'Basel-Stadt' },
    { kuerzel: 'fr', kurz: 'FR', lang: 'Freiburg' },
    { kuerzel: 'ge', kurz: 'GE', lang: 'Genf' },
    { kuerzel: 'gl', kurz: 'GL', lang: 'Glarus' },
    { kuerzel: 'gr', kurz: 'GR', lang: 'Graubünden' },
    { kuerzel: 'ju', kurz: 'JU', lang: 'Jura' },
    { kuerzel: 'lu', kurz: 'LU', lang: 'Luzern' },
    { kuerzel: 'ne', kurz: 'NE', lang: 'Neuenburg' },
    { kuerzel: 'nw', kurz: 'NW', lang: 'Nidwalden' },
    { kuerzel: 'ow', kurz: 'OW', lang: 'Obwalden' },
    { kuerzel: 'sg', kurz: 'SG', lang: 'St. Gallen' },
    { kuerzel: 'sh', kurz: 'SH', lang: 'Schaffhausen' },
    { kuerzel: 'so', kurz: 'SO', lang: 'Solothurn' },
    { kuerzel: 'sz', kurz: 'SZ', lang: 'Schwyz' },
    { kuerzel: 'tg', kurz: 'TG', lang: 'Thurgau' },
    { kuerzel: 'ti', kurz: 'TI', lang: 'Tessin' },
    { kuerzel: 'ur', kurz: 'UR', lang: 'Uri' },
    { kuerzel: 'vd', kurz: 'VD', lang: 'Waadt' },
    { kuerzel: 'vs', kurz: 'VS', lang: 'Wallis' },
    { kuerzel: 'zg', kurz: 'ZG', lang: 'Zug' },
    { kuerzel: 'zh', kurz: 'ZH', lang: 'Zürich' },
];

/**
 * Common form validators, to be used as validator functions in the createValidator() function from geofy lib
 */
export const formValidators = {
    /** Value is required: */

    /** Only alpha-chars */
    charsOnly: (val: string | null, errMsg: string = 'Nur alphanumerische Zeichen erlaubt') => {
        const pattern = /[^0-9]/;
        return validateRegex(pattern, errMsg)(val);
    },

    /** has number */
    hasNumber: (value: string | null) => {
        const pattern = /.*[0-9]+.*/;
        return value ? pattern.test(value) || 'Nummer benötigt' : true;
    },

    passwordComplexity: (val: string) => {
        return (
            val.length === 0 ||
            (val.length >= 8 &&
                val.match(/[a-zöäüéàèç]/) !== null &&
                val.match(/[A-ZÖÄÜÉÀÈÇ]/) !== null &&
                val.match(/[0-9]/) !== null) ||
            getI18n().t('passwort_zu_schwach')
        );
    },

    // isInt: () => (value) => {
    //     const vueI18n = getI18n();
    //     return value ? /^\d*$/.test(value) || vueI18n.t('int_only') : true;
    // },

    // houseNumber: (value) => {
    //     const vueI18n = getI18n();
    //     const pattern = /^[0-9a-zA-Z]*\.?[0-9a-zA-Z]*$/;
    //     return value ? pattern.test(value) || vueI18n.t('invalid_house_number') : true;
    // },

    // iban: (value) => {
    //     if (!value) {
    //         return false;
    //     }
    //     if (value.startsWith('CH') || value.startsWith('LI')) {
    //         value = value.replaceAll(' ', '');
    //         return (value || '').length === 21 || `${value.length}/${21}`;
    //     }
    //     if (value.startsWith('AT')) {
    //         value = value.replaceAll(' ', '');
    //         return (value || '').length === 20 || `${value.length}/${20}`;
    //     }
    //     if (value.startsWith('DE')) {
    //         value = value.replaceAll(' ', '');
    //         return (value || '').length === 22 || `${value.length}/${22}`;
    //     }
    //     return true;
    // },

    // isTelefon: (value) => {
    //     const vueI18n = getI18n();
    //     const pattern = /^[+]?[\d\s]*$/;
    //     return value ? pattern.test(value) || vueI18n.t('invalid_telefon') : true;
    // },

    // coordinates: (value) => {
    //     if (!value) {
    //         return true;
    //     }
    //     const vueI18n = getI18n();
    //     const pattern = /^[0-9'.]*$/;

    //     let coords = value.replaceAll(' ', '').replaceAll("'", '').split('/');
    //     if (coords.length !== 2) {
    //         return vueI18n.t('invalid_coordinates');
    //     }
    //     if (
    //         !pattern.test(coords[0]) ||
    //         isNaN(parseFloat(coords[0])) ||
    //         parseFloat(coords[0]) < 2692300 ||
    //         parseFloat(coords[0]) > 2753650
    //     ) {
    //         return vueI18n.t('invalid_coordinates');
    //     }
    //     if (
    //         !pattern.test(coords[1]) ||
    //         isNaN(parseFloat(coords[1])) ||
    //         parseFloat(coords[1]) > 1283500 ||
    //         parseFloat(coords[1]) < 1248300
    //     ) {
    //         return vueI18n.t('invalid_coordinates');
    //     }

    //     return true;
    // },

    // coordinateEast: (value) => {
    //     if (!value) {
    //         return true;
    //     }
    //     const vueI18n = getI18n();
    //     const pattern = /^[0-9'.]*$/;

    //     if (
    //         !pattern.test(value) ||
    //         isNaN(parseFloat(value)) ||
    //         parseFloat(value) < 2692300 ||
    //         parseFloat(value) > 2753650
    //     ) {
    //         return vueI18n.t('invalid_coordinate_east');
    //     }
    //     return true;
    // },

    // coordinateNorth: (value) => {
    //     if (!value) {
    //         return true;
    //     }
    //     const vueI18n = getI18n();
    //     const pattern = /^[0-9'.]*$/;
    //     if (
    //         !pattern.test(value) ||
    //         isNaN(parseFloat(value)) ||
    //         parseFloat(value) > 1283500 ||
    //         parseFloat(value) < 1248300
    //     ) {
    //         return vueI18n.t('invalid_coordinate_north');
    //     }
    //     return true;
    // },
};
